import { ATTACKS } from '../game/combat';

export const DEFAULT_IMPACT_WORDS = {
  generic: '¡PUM!',
  punch: ATTACKS.punch.label,
  kick: ATTACKS.kick.label,
  uppercut: ATTACKS.uppercut.label,
  spin: ATTACKS.spin.label,
  slam: ATTACKS.slam.label,
  pipe: '¡CLANG!',
  plank: '¡CRACK!',
  bottle: '¡CRASH!',
  shotgun: '¡BOOM!',
  bazooka: '¡KABOOM!',
  greatsword: '¡TAJAZO COLOSAL!',
  warhammer: '¡MAZAZO BRUTAL!',
  chair: '¡SILLAZO!',
} as const;
export type ImpactWordKey = keyof typeof DEFAULT_IMPACT_WORDS;
export type ImpactWords = Record<ImpactWordKey, string>;
export const IMPACT_WORDS_STORAGE_KEY = 'futbolito-bravo-impact-words';

export function normalizeImpactWords(value: unknown): ImpactWords {
  const source = value && typeof value === 'object' ? value as Record<string, unknown> : {};
  return Object.fromEntries(Object.entries(DEFAULT_IMPACT_WORDS).map(([key, fallback]) => {
    const text = typeof source[key] === 'string'
      ? Array.from((source[key] as string).replace(/\s+/gu, ' ').trim()).slice(0, 24).join('') : '';
    return [key, text || fallback];
  })) as ImpactWords;
}

export function loadImpactWords(): ImpactWords {
  try {
    return normalizeImpactWords(JSON.parse(localStorage.getItem(IMPACT_WORDS_STORAGE_KEY) ?? 'null'));
  } catch {
    return { ...DEFAULT_IMPACT_WORDS };
  }
}
